import { OrderTransactionState, TransactionState, TransactionType } from '../interfaces';

export const _getTransactionBadgeType = (stateId: TransactionState): string | undefined => {
    switch (stateId) {
        case TransactionState.Done:
            return 'success';
        case TransactionState.Doing:
        case TransactionState.ManualDoing:
        case TransactionState.ReadyToWithdraw:
        case TransactionState.WaitingForOtpConfirmation:
        case TransactionState.WaitingForAdminConfirmation:
        case TransactionState.WaitingForNetworkPayout:
        case TransactionState.WaitingForTime:
            return 'info';
        case TransactionState.Failed:
        case TransactionState.Rejected:
            return 'danger';
        case TransactionState.WaitingForPayment:
        case TransactionState.WaitingForConfirmation:
            return 'warning';
        default:
            return undefined;
    }
};

export const _getTransactionTypeBadgeType = (typeId: TransactionType): string | undefined => {
    switch (typeId) {
        case TransactionType.Deposit:
        case TransactionType.Reward:
            return 'success';
        case TransactionType.AffiliateDeposit:
        case TransactionType.ReferralWithdrawal:
            return 'info'
        case TransactionType.Withdraw: return 'danger';
        default: return undefined;
    }
}

export const _getOrderTransactionBadgeType = (stateId: OrderTransactionState): string | undefined => {
    switch (stateId) {
        case OrderTransactionState.Done:
        case OrderTransactionState.Paid:
            return 'success';
        case OrderTransactionState.WaitingForPayment:
        case OrderTransactionState.WaitingForDestinationWithdraw:
        case OrderTransactionState.WaitingForFirstPurchaseTime:
        case OrderTransactionState.WaitingForReceiptVerification:
            return 'info';
        case OrderTransactionState.Rejected:
            return 'danger';
        case OrderTransactionState.Doing:
            return 'warning';
        default:
            return undefined;
    }
};
